import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';

export class RegisterAuthorizeNetCommand extends IRequestCommand<
  ICommandResponse,
  ErrorDetails,
  IRegisterAuthorizeNetParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.POST;
  override _commandUrl = 'vendor/authorize';
  public override setParameters(parameters: IRegisterAuthorizeNetParameters) {
    this._commandBody = parameters;
  }
}

export interface IRegisterAuthorizeNetParameters extends ICommandParameters {
  apiLoginId: string;
  transactionKey: string;
  userId: number;
}
